// extracted by mini-css-extract-plugin
export default {"root":"ContentPane_root__vV1NU","container":"ContentPane_container__GCs3s","withRightSideBar":"ContentPane_withRightSideBar__amhNK"};